import React from 'react';
import { TrashIcon, ArrowLongUpIcon, ArrowLongDownIcon, PhotoIcon } from '@fourthwall/icons';
import { ModalBox } from '../../../partials/ModalBox';
import * as S from './MobileContextMenu.styled';
import { Icon } from '../../Icon';
import { useModalContext } from '../../../providers/ModalProvider';
const MobileContextMenuModal = ({ onView, onMoveUp, onMoveDown, onDelete, }) => {
    const { close } = useModalContext();
    const handleAction = (action) => {
        close();
        setTimeout(() => {
            action();
        }, 0);
    };
    return (React.createElement(ModalBox, { size: "small", withoutPadding: true, withoutCloseButton: true, onClose: close },
        React.createElement(S.List, null,
            React.createElement(ListItem, { icon: PhotoIcon, label: "View full image", onClick: () => handleAction(onView) }),
            React.createElement(ListItem, { icon: ArrowLongUpIcon, label: "Move up", onClick: () => handleAction(onMoveUp) }),
            React.createElement(ListItem, { icon: ArrowLongDownIcon, label: "Move down", onClick: () => handleAction(onMoveDown) }),
            React.createElement(ListItem, { icon: TrashIcon, label: "Delete image", onClick: () => handleAction(onDelete) }))));
};
const ListItem = ({ icon, label, onClick, }) => {
    return (React.createElement(S.Item, { onClick: onClick, key: label },
        React.createElement(Icon, { component: icon, height: 12, width: 12 }),
        label));
};
export default MobileContextMenuModal;
